export enum RangeSettingsOption {
  WorkWeek = "workWeek"
}
